import React from 'react';

import "./LogoutButton.scss";
import { Button } from '@randajan/jet-react/dom/form';
import { bifrost, userBeam } from '../../../config/bifrost';

export const LogoutButton = (props)=>{
    const {children} = props;
    
    const onSubmit = _=>bifrost.tx("/user/logout");

    return (
        <Button className="LogoutButton" onSubmit={onSubmit}>{children || "Odhlásit se"}</Button>
    )
}

